
export default function (state) {
    let te = /^[а-яґєіїё\s\/'\/`\-]+[а-яґєіїё]+$/ui;
    return function (value) {
        return te.test(value)
    }
}
